module.exports = __webpack_public_path__ + "static/img/13冠恒.9018041.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/13冠恒.jpg
// module id = wbEF
// module chunks = 1